import React from "react";
import Preloader from "../../helper/Preloader"; 
import FooterOne from "../../components/FooterOne";
import BottomFooter from "../../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import HeaderOneVendorStore from "../../componentsAmazon/HeaderOneVendorStore";
import VendorsListTwoAmazon from "../../componentsAmazon/VendorsListTwoAmazon";

const VendorStorePage = () => {

  return (

    <>

      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#232F3F" />

} 
      {/* HeaderOneCustomer */}
      <HeaderOneVendorStore />
 

      {/* VendorsListTwoAmazon */}
      <VendorsListTwoAmazon />
 
 

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default VendorStorePage;
